    angular.module('egg.delivery', ['core', 'clients'])
        .constant('EggDeliveryConst', {
            "expirationDays": 28,
            "filteringActive": true
        })
        .factory('EggDelivery', function ($resource) {
            return $resource('/crm/api/egg-delivery/:id', {}, {
                table: {method: 'GET', isArray: false, url: '/crm/api/egg-delivery/table'},
                update: {method: 'PUT'},
                remove: {method: 'DELETE'}
            });
        })
        .factory('EggDeliveryItem', function ($resource) {
            return $resource('/crm/api/egg-delivery-item', {}, {
                table: {method: 'GET', isArray: true, url: '/crm/api/egg-delivery-item/table'},
            });
        })
        .directive('deliveryOverLimitFlag', function () {
            return {
                scope: {
                    item: "="
                },
                template: '<i class="fa fa-sm fa-flag over-limit-indicator" title="Przekroczono dzienny limit przyjęcia towaru (na podst. daty zniesienia)" ng-if="item.overLimit"></i>'
            }
        })
        .service('EggFormsHelper', function () {
            this.availableClients = function (clientSettings, clients, filteringActive) {
                var settings = clientSettings || [];
                clients = clients || [];
                var clientsIds = clients.map(function (c) {
                    return c.id;
                });
                if (filteringActive) {
                    var clientsFromSettings = settings
                        .map(function (s) {
                            return s.client;
                        })
                        .filter(function (c) {
                            return clientsIds.indexOf(c.id) === -1
                        });
                    clients = clients.concat(clientsFromSettings);
                }
                return clients;
            };
            this.clientFiltering = function (selected, clientSettings, filteringActive) {
                return function (item) {
                    if (!filteringActive)
                        return true;
                    if(!clientSettings)
                        return false;
                    var clientIds = clientSettings.map(function (s) {
                        return s.client.id;
                    });
                    return clientIds.indexOf(item.id) > -1 || (angular.isDefined(selected) && item.id === selected.id);
                }
            };
            this.productFiltering = function (selectedProduct, selectedClient, clientSettings, filteringActive) {
                return function (item) {
                    if (!filteringActive)
                        return true;
                    if (angular.isUndefined(item)) {
                        return false;
                    }
                    var products = productsForClient(clientSettings, selectedClient);
                    var productIds = products.map(function (s) {
                        return s.id;
                    });
                    return productIds.indexOf(item.id) > -1 || (angular.isDefined(selectedProduct) && item.id === selectedProduct.id);
                }
            };
            this.productSettingFiltering = function (selectedProduct, selectedClient, clientSettings, filteringActive) {
                return function (item) {
                    if (!filteringActive)
                        return true;
                    if (angular.isUndefined(item)) {
                        return false;
                    }
                    var products = productSettingsForClient(clientSettings, selectedClient);
                    var productIds = products.map(function (s) {
                        return s.product.id;
                    });
                    return productIds.indexOf(item.id) > -1 || (angular.isDefined(selectedProduct) && item.id === selectedProduct.id);
                }
            };
            this.productSettings = function (settings, client, product) {
                if (!client || !product)
                    return;

                var productSettings = productSettingsForClient(settings, client);
                return productSettings
                    .filter(function (e) {
                        return e.product.id === product.id;
                    })
                    .pop();
            };

            function productSettingsForClient(clientSettings, client) {
                if (angular.isUndefined(client))
                    return [];
                var settings = clientSettings || [];

                var set = settings
                    .filter(function (e) {
                        return e.client.id === client.id;
                    })
                    .pop();
                if (set) {
                    return set.productSettings;
                } else
                    return [];
            }

            function productsForClient(clientSettings, client) {
                if (angular.isUndefined(client))
                    return [];
                var settings = clientSettings || [];

                var set = settings
                    .filter(function (e) {
                        return e.client.id === client.id;
                    })
                    .pop();
                if (set)
                    return set.products;
                else
                    return [];
            }
        })
        .service('EggDeliveryService', function ($q, $rootScope, $cookies, toastr, modals, EggDelivery) {
            this.editModal = function (entity) {
                return modals.open('app/egg/delivery/edit-modal.tpl.html', 'EggDeliveryDialogController', entity, {size: "lg"});
            };
            this.addModal = function (params) {
                var entity = {
                    id: null,
                    deliveryDate: moment(),
                    items: []
                };

                angular.extend(entity, params);
                return this.editModal(entity);
            };
            this.showModal = function (entity) {
                EggDelivery.get({id: entity.id}).$promise.then(function (item) {
                    return modals.open('app/egg/delivery/show-modal.tpl.html', 'EggDeliveryShowController', item, {size: "lg"});
                });
            };
            this.remove = function (item) {
                return modals.confirmDelete(item.number, function () {
                    return EggDelivery.delete({id: item.id}, function () {
                        $rootScope.$broadcast('egg.delivery.updated');
                    }).$promise;
                });
            };
            this.clone = function (id) {
                var that = this;
                var entity = {};
                EggDelivery.get({id: id}, function (order) {
                    entity.id = null;
                    entity.client = order.client;
                    entity.description = order.description;
                    entity.items = [];
                    angular.forEach(order.items, function (item) {
                        var it = {
                            id: null,
                            product: item.product,
                            quantity: item.quantity,
                            unit: item.unit,
                            layingDate: moment(item.layingDate),
                            expirationDate: moment(item.expirationDate)
                        };
                        entity.items.push(it);
                    });
                    return that.addModal(entity);
                });
            };
            this.settingsModal = function () {
                return modals.open('app/egg/delivery/settings-modal.tpl.html', 'EggDeliverySettingsController', {}, {size: 'lg'});
            };
            this.saveOrUpdate = function (item) {
                var deferred = $q.defer();

                var onSaveSuccess = function (result) {
                    $rootScope.$broadcast('egg.delivery.updated');
                    toastr.success("Zapisano");
                    deferred.resolve(result);
                };

                var onSaveError = function (failed) {
                    if (failed.status === 400) {
                        modals.open('app/egg/delivery/daily-limit-reached-modal.tpl.html', 'EggDeliveryLimitReachedController', {item: item, outOfLimitList: failed.data}, {size: "md"})
                            .then(sendRequest, onSaveError);
                    } else {
                        deferred.reject(failed);
                    }
                };

                var sendRequest = function (item) {
                    if (item.id !== null) {
                        EggDelivery.update(item, onSaveSuccess, onSaveError);
                    } else {
                        EggDelivery.save(item, onSaveSuccess, onSaveError);
                    }
                };

                sendRequest(item);
                return deferred.promise;
            }
        })
        .controller('EggDeliveryLimitReachedController', function ($scope, toastr, data, $uibModalInstance) {

            $scope.outOfLimitList = data.outOfLimitList;
            $scope.item = data.item;

            $scope.cancel = function () {
                $uibModalInstance.dismiss('Canceled');
            };

            $scope.yes = function () {
                $scope.item.overLimitConfirmed = true;
                $uibModalInstance.close($scope.item);
            };

        })
        .controller('EggDeliverySettingsController', function ($scope, toastr, $uibModalInstance, ModuleSettings, Client, Product, uiSelectFix) {

            ModuleSettings.get({module: "egg-delivery"}).$promise.then(function (settings) {
                $scope.item = settings;
            });
            $scope.uiSelectFix = uiSelectFix;

            $scope.cancel = function () {
                $uibModalInstance.dismiss('Canceled');
            };

            $scope.save = function (item) {
                $scope.isSaving = true;
                return ModuleSettings.save({module: "egg-delivery"}, item, function (saved) {
                    $scope.isSaving = false;
                    toastr.success("Zapisano ustawienia");
                    $uibModalInstance.close(saved);
                }, function (failed) {
                    $scope.isSaving = false;
                });
            };

            $scope.refreshClients = function (q) {
                if (!$scope.clientsLoading) {
                    $scope.clientsLoading = true;
                    Client.autocomplete({q: q}).$promise.then(function (items) {
                        $scope.clients = items;
                        $scope.clientsLoading = false;
                    });
                }
            };

            $scope.refreshProducts = function (q) {
                if (!$scope.productsLoading) {
                    $scope.productsLoading = true;
                    Product.autocomplete(q).then(function (items) {
                        $scope.products = items;
                        $scope.productsLoading = false;
                    });
                }
            };

            $scope.cloneClientLine = function (line) {
                var productSettings = angular.copy(line.productSettings);
                return {productSettings: productSettings};
            }
        })
        .controller('EggDeliveryListController', function ($scope, page, $state, $stateParams, EggDeliveryService, Product) {
            var vm = this;
            vm.filters = angular.copy($stateParams);
            vm.page = page;
            vm.EggDeliveryService = EggDeliveryService;
            vm.refreshProducts = function (q) {
                Product.autocomplete(q,100).then(function (items) {
                    vm.products = items;
                });
            };
            vm.reset = function () {
                vm.filters = {}
            }

            $scope.$on('egg.delivery.updated', function () {
                $state.reload();
            });
        })
        .controller('EggDeliveryShowController', function ($scope, $uibModalInstance, data, EggDelivery, EggDeliveryService) {
            $scope.item = data;

            $scope.cancel = function () {
                $uibModalInstance.dismiss('Canceled');
            };

            $scope.delete = function (item) {
                $scope.isSaving = true;
                EggDeliveryService.remove(item).then(function () {
                    $uibModalInstance.dismiss('Canceled');
                    $scope.isSaving = false;
                }, function () {
                    $scope.isSaving = false;
                });
            };

            $scope.edit = function (item) {
                $scope.cancel();
                EggDeliveryService.editModal(item);
            };
        })
        .controller('EggDeliveryDialogController', function ($timeout, $scope, $rootScope, $filter, $uibModalInstance, data, toastr, Client, ClientService, Product, ProductService, Unit, Numeration, EggDelivery, EggDeliveryConst, ModuleSettings, EggFormsHelper, EggDeliveryService) {

            $scope.ProductService = ProductService;
            $scope.EggFormsHelper = EggFormsHelper;
            $scope.filteringActive = EggDeliveryConst.filteringActive;
            $scope.settings = ModuleSettings.get({module: "egg-delivery"});
            $scope.item = data;

            $scope.onLayingDateChanged = function (item) {
                item.expirationDate = calculateExpirationDate(item.layingDate);
            };

            $scope.onTotalQuantityOrWastePercentChange = function (item) {
                item.quantity = parseInt(item.totalQuantity - (item.totalQuantity * item.wastePercent / 100));
            };

            $scope.addItem = function () {
                var newItem = {
                    totalQuantity: 0,
                    wastePercent: 0,
                    quantity: 0,
                    layingDate: moment()
                };
                $scope.onLayingDateChanged(newItem);
                $scope.onTotalQuantityOrWastePercentChange(newItem);
                $scope.item.items.push(newItem);
            };

            if (data.id === null) {
                Numeration.nextNumber({clazz: "pl.multisoft.modules.egg.delivery.EggsDelivery"}).$promise.then(function (result) {
                    data.number = result.number;
                });
                if ($scope.item.items.length === 0)
                    $scope.addItem();
            }

            $scope.refreshClients = function (q) {
                if (!$scope.clientsLoading) {
                    $scope.clientsLoading = true;
                    Client.autocomplete({q: q}).$promise.then(function (items) {
                        $scope.clients = items;
                        $scope.clientsLoading = false;
                    });
                }
            };

            $scope.refreshProducts = function (q) {
                if (!$scope.productsLoading) {
                    $scope.productsLoading = true;
                    Product.autocomplete(q).then(function (items) {
                        $scope.products = items;
                        $scope.productsLoading = false;
                    });
                }
            };

            $scope.cancel = function () {
                $uibModalInstance.dismiss('Canceled');
            };

            $scope.save = function () {
                $scope.isSaving = true;
                var toSave = angular.copy($scope.item);
                toSave.deliveryDate = moment(toSave.deliveryDate).format("YYYY-MM-DD");
                angular.forEach(toSave.items, function (item) {
                    item.layingDate = moment(item.layingDate).format("YYYY-MM-DD");
                    item.expirationDate = moment(item.expirationDate).format("YYYY-MM-DD");
                });

                EggDeliveryService.saveOrUpdate(toSave).then(onSaveSuccess, onSaveError).catch(onSaveError);
            };

            $scope.cloneItem = function (item) {
                var newItem = angular.copy(item);
                newItem.id = null;
                $scope.item.items.push(newItem);
            };
            $scope.cloneItem_1d = function (item) {
                var newItem = angular.copy(item);
                newItem.id = null;
                newItem.layingDate = moment(newItem.layingDate).add(1, 'days');
                newItem.expirationDate = moment(newItem.expirationDate).add(1, 'days');
                $scope.item.items.push(newItem);
            };

            function calculateExpirationDate(layingDate) {
                return moment(layingDate).add(EggDeliveryConst.expirationDays, 'days');
            }

            var onSaveSuccess = function (result) {
                $uibModalInstance.close(result);
                $scope.isSaving = false;
            };

            var onSaveError = function () {
                $scope.isSaving = false;
            };

            $scope.addClient = function () {
                ClientService.addModal().then(function (client) {
                    $scope.item.client = client;
                    $scope.onClientChanged(client);
                    $scope.refreshClients();
                });
            };

            Unit.list().$promise.then(function (items) {
                $scope.units = items;
            });

            $scope.onProductChanged = function (product, item, clientSettings, selectedClient) {
                if (angular.isDefined(product)) {
                    if (product.unit)
                        item.unit = product.defaultUnit;
                    if (product.symbol)
                        item.product.productSymbol = product.symbol;
                    if (product.name)
                        item.product.productName = $filter('localized')(product.name);

                    Product.unitConverters({id: product.id}).$promise.then(function (unitConverters) {
                        item.product.systemProduct.unitConverters = unitConverters;
                    });

                    var productSettings = EggFormsHelper.productSettings(clientSettings, selectedClient, product);
                    item.wastePercent = 0;
                    if(productSettings){
                        item.wastePercent = productSettings.deliveryWastePercent || 0;
                    }

                    $scope.onTotalQuantityOrWastePercentChange(item);
                } else
                    delete item.unit;

            };
        })
        .run(function (NavbarLeftMenu) {
            NavbarLeftMenu.add({
                authorities: "ROLE_MODULE_EGG_DELIVERY",
                path: "/egg-delivery",
                ico: "fa fa-fw fa-cube",
                name: 'egg.delivery.menu',
                order: 81
            });
        })
        .config(function ($stateProvider) {
            $stateProvider.state('eggDeliveryList', {
                parent: 'app',
                url: '/egg-delivery?{page:int}&{size:int}&sort&search&periodStart&periodEnd&{client:int}&{product:int}',
                data: {
                    authorities: ['ROLE_MODULE_EGG_DELIVERY']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/egg/delivery/list.tpl.html',
                        controller: 'EggDeliveryListController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    page: function (EggDelivery, $stateParams) {
                        return EggDelivery.table(angular.copy($stateParams)).$promise;
                    }
                }
            });
        });
